var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('h2',{staticClass:"is-size-6 has-text-centered"},[_vm._v("詳細情報")]),_c('div',[_c('p',{staticStyle:{"white-space":"pre-wrap","word-break":"break-all"}},[_c('LinkableText',{attrs:{"value":_vm.value}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }